import React from "react";
import { cancelIcon, logOutIcon } from "../../../../Base/SVG";

export default function Start() {
  return (
    <div className="guides">
      <h5>
        <span className="purple"></span> How to start?
      </h5>
      <div className="guides__text">
        <h5 className="note">
          To get started, you need to connect your MetaMask wallet
          <button className="note__close">{cancelIcon}</button>
        </h5>
        <p>
          Click
          <a href="#" className="button primary">
            Connect
          </a>
          in the lower left corner of the side menu.
        </p>
        <p>Confirm the operation in MetaMask.</p>
        <p>
          After connecting the wallet, your address will be displayed on the
          site:
        </p>
        <button className="button box">
          <img
            src={process.env.PUBLIC_URL + "/images/metamask.svg"}
            alt="metamask"
          />
          <span> 0x022...cf5796</span>
          {logOutIcon}
        </button>
      </div>
    </div>
  );
}
